export const CLIMB_SPLIT_TYPES = {
    CLIMB_ACTIVE: 'CLIMB_ACTIVE',
    CLIMB_REST: 'CLIMB_REST'
};

export const CLIMB_SPLIT_STATUSES = {
    CLIMB_COMPLETED: 'CLIMB_COMPLETED',
    CLIMB_ATTEMPTED: 'CLIMB_ATTEMPTED'
};

export const getChartData = (typedSplits) => {
    const defaultDatum = {
        sends: 0,
        completed: 0,
        attempted: 0,
        gradeValue: {}
    };
    let chartData = {};
    typedSplits.forEach((typedSplit) => {
        if (typedSplit.type === CLIMB_SPLIT_TYPES.CLIMB_ACTIVE) {
            let datum = chartData[typedSplit.gradeValue.valueKey];
            if (!datum) {
                datum = {
                    ...defaultDatum
                };
            }

            switch (typedSplit.status) {
                case CLIMB_SPLIT_STATUSES.CLIMB_ATTEMPTED:
                    datum.attempted++;
                    break;
                case CLIMB_SPLIT_STATUSES.CLIMB_COMPLETED:
                default:
                    if (typedSplit.climbSend) {
                        datum.sends++;
                    } else {
                        datum.completed++;
                    }
                    break;
            }

            chartData[typedSplit.gradeValue.valueKey] = {
                ...datum,
                gradeValue: typedSplit.gradeValue
            };
        }
    });

    return Object.values(chartData).sort((data1, data2) => {
        return data1.gradeValue.sortOrder - data2.gradeValue.sortOrder;
    });
};

export const formatRouteDifficulty = (difficultyScale, difficultyKey, difficultyJSON) => {
    if (difficultyJSON && difficultyJSON[difficultyScale] && difficultyJSON[difficultyScale][difficultyKey]) {
        return difficultyJSON[difficultyScale][difficultyKey].value;
    }
    return null;
};

/*
 * Indoor Climb key representation:
 * Key CLIMB_ACTIVE
 * Key CLIMB_REST
 */
export const getSplitSummaries = (splitSummaries) => {
    return splitSummaries.reduce((acc, item) => {
        acc[item.splitType] = item;
        return acc;
    }, {});
};

/**
 * Returns True if Climb Mode is Simple, and False if Advanced
 * @param splitSummaries - Array
 * @returns boolean
 */
export const isSimpleMode = (splitSummaries) => {
    return splitSummaries && splitSummaries.some((splitSummary) => splitSummary.mode === 'SIMPLE');
};

export const hasGradeValues = (typedSplits) => {
    for (let i = 0; i < typedSplits.length; i++) {
        let typedSplit = typedSplits[i];
        if (typedSplit.type === CLIMB_SPLIT_TYPES.CLIMB_ACTIVE && !typedSplit.gradeValue) {
            return false;
        }
    }
    return true;
};
